import { App, Button, type FormInstance } from "antd";
import { displaySubmissionError } from "./displaySubmissionError";
import { useFormSubmission } from "./useFormSubmission";
import type { ExistingPatient } from "../existingPatient";
import type { NiceModalHandler } from "@ebay/nice-modal-react";
import type { PatientUpdateForm } from "api/requests";

interface PaymentFooterProps2 {
    /** Handler for the modal dialog so we can close it. */
    readonly hostModal: NiceModalHandler;

    /** The form we are going to submit. */
    readonly paymentForm: FormInstance<PatientUpdateForm>;

    /** The existing patient we are updating, if any. */
    readonly existingPrp: ExistingPatient;
}

/** Footer for the New Payment modal dialog. Displays actions for the user to perform. */
export const PaymentFooter = ({ hostModal, paymentForm, existingPrp }: PaymentFooterProps2) => {
    const { modal } = App.useApp();

    const { isPending, submit } = useFormSubmission(paymentForm, existingPrp, {
        onError: (err) => displaySubmissionError(modal, err, hostModal),
        onSuccess: () => hostModal.hide(),
    });

    const addToList = () => void submit("addToList");
    const sendRequest = () => void submit("sendRequest");

    return (
        <>
            <Button type="default" htmlType="submit" value="addToList" loading={isPending} onClick={addToList}>
                Add To List
            </Button>
            <Button
                id="send-new-payment-request-btn"
                type="primary"
                htmlType="submit"
                value="sendRequest"
                loading={isPending}
                onClick={sendRequest}
            >
                Send Request
            </Button>
        </>
    );
};
